import React from 'react';
import { Typography, Box, IconButton, Avatar, Tooltip } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const onPrimaryButtonSx = {
  bgcolor: 'onPrimary.hover',
  '&:hover': {
    bgcolor: 'onPrimary.active',
  },
};

const initial = (user) => user?.email?.charAt(0).toUpperCase();

/** Werkbalk op mobiel: hamburger, logo en avatar. */
export default function MobileToolbarContent({ user, onDrawerToggle, onOpenMenu }) {
  return (
    <>
      <Tooltip title="Menu openen">
        <IconButton
          aria-label="Menu openen"
          color="inherit"
          edge="start"
          onClick={onDrawerToggle}
          sx={{ mr: 2, ...onPrimaryButtonSx }}
        >
          <MenuIcon />
        </IconButton>
      </Tooltip>
      <Link
        to="/"
        style={{
          color: 'inherit',
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          marginRight: '8px',
        }}
      >
        <img
          src="/logo192.png"
          alt="BEM.report Logo"
          style={{
            width: 28,
            height: 28,
            borderRadius: '4px',
            filter: 'brightness(0) invert(1)',
          }}
        />
      </Link>
      <Typography
        variant="h6"
        component={Link}
        to="/"
        sx={{
          color: 'inherit',
          textDecoration: 'none',
          display: { xs: 'none', sm: 'block' },
          fontWeight: 600,
          letterSpacing: 0.5,
        }}
      >
        BEM.report
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      <Tooltip title="Accountmenu openen">
        <IconButton
          aria-label="Accountmenu openen"
          size="large"
          onClick={onOpenMenu}
          color="inherit"
          edge="end"
          sx={onPrimaryButtonSx}
        >
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: 'onPrimary.active',
              fontSize: '0.875rem',
            }}
          >
            {initial(user)}
          </Avatar>
        </IconButton>
      </Tooltip>
    </>
  );
}
